
import ViewController from './Main.svelte'
import GlobalThings from '../../Globals/min.js'


window.addEventListener('load', async () => {

	await GlobalThings.initFirebase();

	if (!currentUser) {
		return window.location.href = '../index.html'
	}

	if (!currentUser.id_cuenta && currentUser.categoria === 'super_administrador') {
		window.location.href = '../05_consola/00_consola.html';
		return;
	}

	try {
		document.querySelector('#img-loader').style.display = 'none'
	}
	catch (e) {}

	const docRefCuenta = await db.collection('cuentas').doc(currentUser.id_cuenta).get();
	const docDataCuenta = GlobalThings.getDataDoc(docRefCuenta);

	initViewController({ docDataCuenta })
	establecer_tutorial_home(docDataCuenta)
})



const initViewController = ({ docDataCuenta }) => {

	new ViewController({
		props: { docDataCuenta },
		target: document.querySelector('body')
	})
}















